import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { TituloReceberResumoModule } from '../../../titulo-receber/resumo';
import { ClienteTituloReceberViewModule } from './view';

import { ClienteTituloComponent } from './cliente-titulo.component';

@NgModule({
    imports: [
        SharedModule,
        TituloReceberResumoModule,
        ClienteTituloReceberViewModule
    ],
    declarations: [
        ClienteTituloComponent
    ],
    exports: [
        ClienteTituloComponent
    ]
})
export class ClienteTituloModule { }
